import { getOrganizationMembers } from "../../api/organizations/organizationsApi";
import { getMyDetails } from "../../api/users/usersApi";

export const loadCurrentUserDetails = async (org_id: string, token: string) => {
    // Check if user is authenticated before making API calls
    const isLoggedIn = typeof window !== 'undefined' && localStorage.getItem("userAuthorized") !== null;
    if (!isLoggedIn || !token || !org_id) {
        return false;
    }

    try {
        const tempMembers = await getOrganizationMembers(token, org_id);

        // Check tempMembers first, before making the second API call
        // Must explicitly check for undefined, null, and ensure it's an object
        if (tempMembers == null || typeof tempMembers !== 'object') {
            return false;
        }

        if (!tempMembers.results || !Array.isArray(tempMembers.results)) {
            return false;
        }

        const user = await getMyDetails(token);

        // Check if user is defined and is an object (not error responses)
        // Must explicitly check for undefined and null BEFORE accessing any properties
        if (user == null || typeof user !== 'object') {
            return false;
        }

        // Now that we know user is an object, check if it has is_superuser property
        if (user.is_superuser === true) {
            return true;
        }

        // Check if user has email property - must check property existence before accessing
        // Use 'in' operator or hasOwnProperty to safely check property existence
        if (!('email' in user) || user.email === undefined || user.email === null || typeof user.email !== 'string') {
            return false;
        }

        // Use validated email for comparison
        const userEmail = user.email;

        // Now safe to iterate and compare emails
        for (const member of tempMembers.results) {
            // Check if member is defined, is an object, and has email property
            if (member && typeof member === 'object' && member.email && typeof member.email === 'string' && member.email === userEmail) {
                return member.role === "admin";
            }
        }
        return false;
    } catch (err) {
        // Silently handle errors - they're already handled by the interceptor
        console.log('Failed to load current user details:', err);
        return false;
    }
}